import { createSlice } from "@reduxjs/toolkit";
import getItem from "../../utils/getItem";

export const theSlice = createSlice({
  name: 'product-settings',
  initialState: {
    list: [],
    loaded: false,
  },
  reducers: {
    loadProductSettings: (state, action) => {
      const data = action.payload;
      state.list = data;
      state.loaded = true;
    },
    addProduct: (state, action) => {
      const { id, name } = action.payload;
      if (getItem(id, state.list)) {
        return;
      }
      state.list.push({ id, name, days: null });
    },
    removeProduct: (state, action) => {
      const { id } = action.payload;
      state.list = state.list.filter(item => item.id !== id);
    },
    updateProductSetting: (state, action) => {
      const {id, data} = action.payload
      let item = getItem(id, state.list);
      if (item) {
        Object.assign(item, data);
      }
    },
  }
});

export const {
  loadProductSettings,
  addProduct,
  removeProduct,
  updateProductSetting,
} = theSlice.actions;
export default theSlice.reducer;
